import { FormattedMessage } from 'react-intl'
import {KTSVG} from '../../../../../../_metronic/helpers'
import {useListView} from '../../core/ListViewProvider'
import {RolesPermissionsListFilter} from './RolesPermissionsListFilter'

const RolesPermissionsListToolbar = () => {
  const {setItemIdForUpdate} = useListView()
  const openAddRolePermissionModal = () => {
    setItemIdForUpdate(null)
  }

  return (
    <div className='d-flex justify-content-end' data-kt-rolepermission-table-toolbar='base'>
      <RolesPermissionsListFilter />

      {/* begin::Export */}
      <button type='button' className='btn btn-light-primary me-3'>
        <KTSVG path='/media/icons/duotune/arrows/arr078.svg' className='svg-icon-2' />
        <FormattedMessage id='TABLE.GENERAL.EXPORT' />      </button>
      {/* end::Export */}

      {/* begin::Add rolepermission */}
      <button type='button' className='btn btn-primary' onClick={openAddRolePermissionModal}>
        <KTSVG path='/media/icons/duotune/arrows/arr075.svg' className='svg-icon-2' />
        <FormattedMessage id='ROLEPERMISSION.TABLE.CREATEROLEPERMISSION' defaultMessage={"ایجاد نقش"} />
      </button>
      {/* end::Add rolepermission */}
    </div>
  )
}

export {RolesPermissionsListToolbar}
